import { combineReducers } from "redux";
import languagesReducer from "./slices/languageSlice";
import booksReducer from "./slices/bookSlice";
import usersReducer from "./slices/userSlice";
import sentencesReducer from "./slices/sentenceSlice";
import filterReducer from "./slices/filterSlice";
import hasPaidReducer from "./slices/hasPaidSlice";
import profileReducer from "./slices/profileSlice";

const rootReducer = combineReducers({
  filters: filterReducer,
  languages: languagesReducer,
  books: booksReducer,
  users: usersReducer,
  sentences: sentencesReducer,
  hasPaid: hasPaidReducer,
  profile: profileReducer,
});

export default rootReducer;
